import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DragSource, DropTarget } from 'react-dnd';
import { findDOMNode } from 'react-dom';
import { compose } from 'redux';
import { swapSlotWithReport, swapSlotWithSlot } from '../flow/actions';

const defaultProps = {};
const propTypes = {
  slotId: PropTypes.number.isRequired
};

class DragWrapper extends Component {
  componentDidMount() {}

  render() {
    const { children, connectDragSource, connectDropTarget } = this.props;
    return connectDragSource(
      connectDropTarget(<div style={{ cursor: 'grab' }}>{children}</div>)
    );
  }
}

/**
 * Drag configs
 */
const dragSpec = {
  beginDrag: props => ({ id: props.slotId, dragType: 'DRAG_SLOT' })
};
const dragCollect = (connector, monitor) => ({
  connectDragSource: connector.dragSource(),
  isDragging: monitor.isDragging()
});
/**
 * Drop configs
 */
const dropSpec = {
  drop: (props, monitor, component) => {
    const { id, dragType, direction } = monitor.getItem();
    if (dragType === 'DRAG_REPORT') {
      props.swapSlotWithReport(id, props.slotId, direction);
    } else if (dragType === 'DRAG_SLOT') {
      props.swapSlotWithSlot(id, props.slotId, direction);
    }
    return;
  },
  hover: (props, monitor, component) => {
    if (!component) return null;

    const dragItem = monitor.getItem();
    const dropItem = {
      id: props.slotId,
      dragType: 'DRAG_SLOT'
    };

    // Don't replace items with themselves
    if (
      dragItem.id === dropItem.id &&
      dragItem.dragType === dropItem.dragType
    ) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get horizontal middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Get pixels to the left
    const hoverClientY = monitor.getClientOffset().y - hoverBoundingRect.top;

    // TODO: add implementation
    // if followings, then call action
    // * report drag in any zones, empty or not
    // * slot drag across original zone
    // * slot drag in same zone but different y

    // get drag direction
    const direction =
      hoverMiddleY < hoverClientY ? 'insertAfter' : 'insertBefore';

    monitor.getItem().direction = direction;
    return;
  }
};
const dropCollect = (connector, monitor) => ({
  connectDropTarget: connector.dropTarget()
});

DragWrapper.defaultProps = defaultProps;
DragWrapper.propTypes = propTypes;

const mapState = ({ dashboardSettings }, ownProps) => {
  const slot =
    dashboardSettings.details.slots.find(s => s.id === ownProps.slotId) || {};
  return {
    position: slot.position
  };
};
const mapDispatch = {
  swapSlotWithReport,
  swapSlotWithSlot
};

const enhancers = compose(
  connect(
    mapState,
    mapDispatch
  ),
  DragSource('DRAG_SLOT', dragSpec, dragCollect),
  DropTarget(['DRAG_REPORT', 'DRAG_SLOT'], dropSpec, dropCollect)
);
export default enhancers(DragWrapper);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Details/components/DragWrapper.jsx